import DateRangePicker from '@/components/shared/DateRangePicker/DateRangePicker.vue';
import dayjs from 'dayjs';

import { createNamespacedHelpers } from 'vuex';
const historyImageMapper = createNamespacedHelpers('history/image');
const advancedSettingMapper = createNamespacedHelpers('global/advancedSetting');

export default {
	name: 'advance-setting',
	components: {
		DateRangePicker,
	},
	data() {
		return {
			DATE_START: 0,
			DATE_END: 1,
		};
	},

	props: {
		icon: {
			type: String,
		},
		title: {
			type: String,
		},
		contents: {
			type: Array,
		},
		typeSetting: {
			type: String,
		},
	},

	computed: {
		...historyImageMapper.mapState(['dateStart', 'dateEnd']),
		...advancedSettingMapper.mapState(['currentConnectedCamera', 'device']),
		hideSelectedCamera() {
			return this.device === 'tablet' || this.device === 'mobile'
		}
	},
	methods: {
		onToggleBtn(id) {
			this.$emit('click-onToggleBtn', id, this.typeSetting);
		},

		onSettingDate(id, rangeDate) {
			this.$emit('click-onSettingDate', id, rangeDate, this.typeSetting);
		},
		onSelectCamera(id, selectedCamera) { 
			this.$emit('click-onSelectCamera', id, selectedCamera, this.typeSetting);
		}
	},
};
